/**
 * The plan modelers the assistant’s pages apply to an API response: the plan type’s model, then
 * the collections derived for the pages’ lead items (see getPlanWithLeadItems). Kept apart from
 * the utilities so that they stay free of the model module, whose API dependencies the utilities’
 * tests stand in for.
 */
import model from '../model'

import { getPlanWithLeadItems } from './utilities'

const modelIepPlan = response => getPlanWithLeadItems(model.iep(response))
const modelIppPlan = response => getPlanWithLeadItems(model.ipp(response))

export { modelIepPlan, modelIppPlan }
